import camelCaseKeysDeep from 'camelcase-keys-deep';
import { UPDATE_EMAIL_SUBSCRIPTIONS_FULFILLED } from '../actions/types'
import type { ActionWithPayload, Subscription } from '../../types'

function updateEmailSubscriptions(
  _state: Array<Subscription>,
  subscriptions: Array<Subscription>
): Array<Subscription> {
  return camelCaseKeysDeep(subscriptions) as Array<Subscription>
}

export function emailSubscriptionsReducer(
  state: Array<Subscription> = [],
  action: ActionWithPayload
): Array<Subscription> {
  switch (action.type) {
    case UPDATE_EMAIL_SUBSCRIPTIONS_FULFILLED:
      return updateEmailSubscriptions(state, action.payload)
    default:
      return state
  }
}


